import { createFileRoute } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader'
import { SandboxDetailPage } from '#features/admin/sandboxes/sandbox-detail-page'

export const Route = createFileRoute('/_app/admin/sandboxes/$name')({
  head: () => ({ meta: [{ title: 'Sandbox details' }] }),
  component: RouteComponent,
  pendingComponent: DefaultLoader,
})

function RouteComponent() {
  const { name } = Route.useParams()
  return <SandboxDetailPage name={name} />
}
